import styled from 'styled-components';

export const DialogContainer = styled.div`
    h3 {
        color: ${props => {
            return props.theme.dark_mode ? '#fff' : '#252525';
        }} !important;
    }
`;

export const ParameterContainer = styled.div`
    h3 {
        color: ${props => {
            return props.theme.dark_mode ? '#fff' : '#252525';
        }} !important;
    }
`;

export const ParameterArea = styled.div`
    padding: 20px 10px;
    border: 1px solid #ddd;

    .row {
        margin: 10px 0px;
    }
`;

export const DeleteParameter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    margin: 0px;
    padding: 0px;

    :hover {
        cursor: pointer;
    }
`;

export const NoAction = styled.div`
    min-height: 100px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const JSONArea = styled.div`
    .variable-value {
        word-break: break-all;
    }
`;
